import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNoClickPhishing = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.793 12.3333C12.6074 11.1201 12.9826 9.24873 12.4391 7.7814C11.8051 6.07025 9.53489 6.15114 7.96709 6.00142L7.92256 3.10309C7.91316 2.49115 7.41443 2 6.80243 2C6.1837 2 5.68213 2.50157 5.68213 3.12029V5.66667M2.68083 2.72656L13.1279 13.7419M5.68174 9.5468L4.88027 8.384C4.55932 7.91833 3.96127 7.733 3.43323 7.93553C2.83671 8.16433 2.51737 8.81213 2.73499 9.4128C3.14077 10.5328 3.7845 11.7828 4.61273 12.8127C5.68387 14.1447 8.56103 14.3105 10.3469 13.5386",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgNoClickPhishing;
